import React, { createContext, useContext } from "react";
//Limitless imports
import { log as pilog } from "../../utils";
import { useWebSocketsHook } from "./WebSocketsHook";
var WebSocketsContext = createContext({});
export var WebSocketsContextProvider = function WebSocketsContextProvider(_ref) {
  var children = _ref.children,
      eventProcessorHook = _ref.eventProcessorHook,
      shouldConnect = _ref.shouldConnect,
      profile = _ref.profile;
  var log = pilog.getLogger("WebSocketContextProvider");
  var hook = useWebSocketsHook(eventProcessorHook, profile);
  React.useEffect(function () {
    log.debug("Ready to connect ".concat(shouldConnect));

    if (shouldConnect) {
      log.debug("Should only be called once");
      hook.connectToWebSocket();
    }
  }, [shouldConnect]); // once this context is destroyed, disconnect from WS

  React.useEffect(function () {
    return function () {
      hook.disconnectFromWebSocket();
    };
  }, []);
  /* if the limitless-root is remove from the page or the window closes, disconnect from web sockets
   *  added for when test-rig kill the node or when the browser is closed.
   */

  React.useEffect(function () {
    var observer;

    if (process.env.REACT_APP_TYPE !== "mobile") {
      window.addEventListener("onbeforeunload", hook.disconnectFromWebSocket);
      var elemToObserve = document.getElementById("limitless-root");

      if (elemToObserve) {
        try {
          observer = new MutationObserver(function () {
            if (!document.getElementById("limitless-root")) {
              hook.disconnectFromWebSocket();
            }
          });
          observer.observe(elemToObserve.parentNode, {
            childList: true,
            subtree: false
          });
        } catch (error) {
          log.warn("Failed to disconnect from web sockets when node was removed from DOM %o", error);
        }
      }
    }

    return function () {
      if (process.env.REACT_APP_TYPE !== "mobile") {
        window.removeEventListener("onbeforeunload", hook.disconnectFromWebSocket);

        if (observer) {
          observer.disconnect();
        }
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(WebSocketsContext.Provider, {
    value: hook
  }, children);
};
export var useWebSockets = function useWebSockets() {
  return useContext(WebSocketsContext);
};
WebSocketsContextProvider.defaultProps = {
  shouldConnect: true
};